import type { IssuePriority, IssueStatus } from '../../shared/schema.ts';
import { PRIORITY_LABELS, STATUS_LABELS } from '../format.ts';

/** A status as one square cell, in the landing page's diagram vocabulary: an empty cell is work
 *  not started, a filled blue cell is work done. */
export function StatusMark({ status }: { status: IssueStatus }) {
  return <span className={`mark status-${status}`} role="img" aria-label={STATUS_LABELS[status]} title={STATUS_LABELS[status]} />;
}

/** The mark and its name together — what a control shows, where the square on its own would be a
 *  legend the page never prints. The mark is decorative here because the name is right beside it;
 *  reading both would say every status twice. */
export function StatusTag({ status }: { status: IssueStatus }) {
  return (
    <span className="status-tag">
      <span className={`mark status-${status}`} aria-hidden="true" />
      {STATUS_LABELS[status]}
    </span>
  );
}

export function PriorityLabel({ priority }: { priority: IssuePriority }) {
  return <span className={`priority priority-${priority}`}>{PRIORITY_LABELS[priority]}</span>;
}

/** A tag. With `onSearch` the name is a button that puts `tag:<name>` in the search — the tag is
 *  already exactly what that axis compares (`addTag` normalizes, so does the box), so a click is
 *  the same term the `tag:` list would have made. */
export function TagChip({ name, onSearch, onRemove }: { name: string; onSearch?: () => void; onRemove?: () => void }) {
  return (
    <span className="chip">
      {onSearch
        ? <button type="button" className="chip-name" title={`Search for ${name}`} onClick={onSearch}>{name}</button>
        : name}
      {onRemove && <button type="button" className="chip-x" aria-label={`Remove tag ${name}`} onClick={onRemove}>×</button>}
    </span>
  );
}
